import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import FolderOpenIcon from '@mui/icons-material/FolderOpen';

import { AppBarWithButtons } from '../../../components/designe/app-bars/app-bar-with-action-buttons/AppBarWithButtons';
import AppEntityAvatar from '../../../components/designe/app-entity-avatar/app-entity-avatar/AppEntityAvatar';
import AppUploadFileButton from '../../../components/designe/buttons/app-upload-file-button/AppUploadFileButton';
import AppFormTextField from '../../../components/designe/forms/app-form-text-field';
import PageContainer from '../../../components/layout/page-container/PageContainer';
import { useNavigationStack } from '../../../context/NavigationStackContext';
import withRouter from '../../../hoc/with-router';
import { useScrollToFirstError } from '../../../hooks/use-scroll-to-first-error';
import { useUnsavedChangesGuard } from '../../../hooks/useUnsavedChangesGuard';
import { AvatarSize, AvatarTypes } from '../../../shared/constants';
import { uploadFilesUtils } from '../../../utils/files/upload-files-utils';
import { useStyles } from './EditProgramCollection.styles';
import { useEditProgramCollectionComponent } from './useEditProgramCollectionComponent';

const EditProgramCollection = (props) => {
  const { params } = props;
  const { t } = useTranslation();
  const { back } = useNavigationStack();
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const { formik, program, isLoading, avatar, setAvatar } =
    useEditProgramCollectionComponent(params.programId);
  const { allowAndLeave, dialog } = useUnsavedChangesGuard({
    isDirty: (formik.dirty || !!avatar) && !formik.isSubmitting,
    leaveAction: back,
  });

  useScrollToFirstError(formik, { fieldOrder: ['title'] });

  return (
    <PageContainer
      title={
        params.programId
          ? t('programs.editProgramCollection')
          : t('programs.newProgramCollection')
      }
      backButton>
      <div className={classes.addProgramWrapper}>
        {dialog}
        <form onSubmit={formik.handleSubmit} className={classes.addProgramForm}>
          <Box className={classes.avatarWrapper}>
            <AppEntityAvatar
              previewStorageLink={program?.avatar?.previewStorageLink}
              storageLink={program?.avatar?.storageLink}
              fileBlob={avatar?.fileBlob}
              size={AvatarSize.l}
              type={AvatarTypes.square}>
              <FolderOpenIcon />
            </AppEntityAvatar>
          </Box>
          <AppUploadFileButton
            variant="outlined"
            label={t('exercises.uploadFile')}
            onFileInput={(e) => {
              uploadFilesUtils(e.target.files, true).then((uploadedFiles) => {
                setAvatar(uploadedFiles[0]);
              });
            }}
          />

          <Box display="flex" flexDirection="column" gap={1} marginTop={1}>
            <AppFormTextField
              label={t('common.title')}
              fullWidth
              autoFocus
              name="title"
              formik={formik}
            />
            <AppFormTextField
              label={t('common.description')}
              fullWidth
              multiline
              minRows={3}
              maxRows={15}
              name="description"
              formik={formik}
            />
          </Box>
          <div className={classes.addProgramButtonWrapper}>
            <AppBarWithButtons
              loading={isLoading}
              onCancelClick={allowAndLeave}
            />
          </div>
        </form>
      </div>
    </PageContainer>
  );
};

export default withRouter(EditProgramCollection);
